import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import { FavoriteBrandsRequestBody } from "@/shared/api/favorite-brands/types";
import { favoriteBrandsUrl } from "@/shared/api/favorite-brands/url";

export const favoriteBrandsMutationApi = {
  // 바이어의 즐겨찾기 브랜드 수정 — 전체 목록을 brand_ids로 덮어쓴다.
  updateFavoriteBrands: async (
    buyerId: number,
    body: FavoriteBrandsRequestBody
  ) =>
    await axiosClient.put(
      favoriteBrandsUrl.root(buyerId),
      toSnakeKeyObject(body)
    ),
};
